module.exports = __webpack_public_path__ + "static/media/aboutUs_16.05a158b2.jpg";